import React from 'react';
import { Spin } from 'antd';

const Load = () => (
  <div className="loader">
    <Spin />
  </div>
);

export default Load;